<template lang="html">
    <div class="d-flex flex-column" v-if="content != null">
        <div class="d-flex flex-row align-items-center">
            <div class="row g-0 align-self-center align-items-center justify-content-center">
                <div class="cta-3 text-danger">Erreur de publication</div>
            </div>
            <button @click="delete_state()" type="button" class="btn btn-outline-danger btn-sm btn-icon btn-icon-only ms-auto"><i class="bi-trash"></i></button>
        </div>

        <div class="text-alternate">{{ human_created_on }}</div>

        <div class="align-items-center mt-2" v-for="(s, index) in this.context.data.Status" :class="get_status_text(s, index)">
            <i class="d-inline-block icon-16 me-2" :class="get_status_icon(s, index)"></i>
            <span>&nbsp;</span><span>{{context.data.POSSIBLE_STATUS[s.key].verbose_name}}</span><span>&nbsp;</span><span>{{s.on|from_now}}</span>
            <div style="padding-left:18px;font-size:12px;color:#555;">{{s.info}}</div>
        </div>
    </div>
</template>

<script>
import tools from "@/tools.js";

export default {
  name: "StatePublicationError",
  props: {
    context: {
      type: Object,
      required: true
    },
    human_created_on: String
  },
  data() {
    return {
      content: { uid: "0" }
    };
  },
  methods: {
    get_status_icon(s, index) {
      if (index === this.context.data.Status.length - 1) {
        return "bi-exclamation-circle has-text-danger";
      }
      if (s.key === "request_rejected" || s.key === "request_failed" || s.key === "stratalis_failed") {
        return "bi-stopwatch has-text-danger";
      }
      return "bi-check-circle has-text-success";
    },
    get_status_text(s, index) {
      if (index === this.context.data.Status.length - 1) {
        return "has-text-danger";
      }
      if (s.key === "request_rejected" || s.key === "request_failed" || s.key === "stratalis_failed") {
        return "has-text-danger";
      }
      return "has-text-success";
    },
    delete_state() {
      this.$emit("state:delete_state");
    }
  },
  created() {
    this.content = tools.deep_copy(this.context);
  }
};
</script>

<style lang="scss" scoped>
</style>
